import { BaseModel } from './base.model';
import { EmailModel } from './email.model';
import { QuestionGroupModel } from './question-group.model';
import { UnconformityModel } from './unconformity.model';

export class QuestionModel extends BaseModel {

    description: string;
    observation: string;
    question_type: number;
    always_visible: boolean;
    observation_visible: boolean;
    question_group_id: number;
    question_id: number;
    okay_description: string;
    disapproved_description: string;
    quantitative_description: string;
    descriptive_limit: number;
    evaluative_type: number;
    operation_type: number;
    operation_value: string;
    weight: number;
    emails: EmailModel[];
    sendEmail: boolean;
    unconformities: UnconformityModel[];
    question_group: QuestionGroupModel;
    item_order: number
    attachment: any
    default_response: string
    origin_id?: number;
    previous_id?: number;
    response: string;

    list_id?: number;
    dyn_list_id?: number;

    static validate(question: QuestionModel): boolean {
        if(question.description && question.question_type) {
            if(question.question_type == 4 && !question.evaluative_type) {
                return false;
            }
            return true;
        }

        return false;
    }

    constructor(question?: QuestionModel) {
        super();
        this.description = question ? question.description || null : null;
        this.observation = question ? question.observation || null : null;
        this.question_type = question ? question.question_type || null : null;
        this.always_visible = question ? question.always_visible || null : null;
        this.observation_visible = question ? question.observation_visible || null : null;
        this.question_group_id = question ? question.question_group_id || null : null;
        this.okay_description = question ? question.okay_description || null : null;
        this.disapproved_description = question ? question.disapproved_description || null : null;
        this.quantitative_description = question ? question.quantitative_description || null : null;
        this.descriptive_limit = question ? question.descriptive_limit || null : null;
        this.evaluative_type = question ? question.evaluative_type || null : null;
        this.operation_type = question ? question.operation_type || null : null;
        this.operation_value= question ? question.operation_value || null : null;
        this.weight = question ? question.weight || null : null;
        this.unconformities = question ? question.unconformities || [] : [];

        this.list_id = question ? question.list_id || null : null;
        this.dyn_list_id = question ? question.dyn_list_id || null : null;

        this.question_group = question ? question.question_group : new QuestionGroupModel;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/question.model.ts